// Copyright (c) 2017 Deere & Company

import AuditPreparation, {getDefaultState as getAuditPreparationDefaultState} from '@deere/cps-it.warranty-model-factory/lib/audit-preparation';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import t from 'tcomb';

const State = t.struct({
    auditPreparation: AuditPreparation,
    busyCounter: BusyCounter,
    isAuditLoaded: t.Boolean,
    isSystemSelectedClaimsModalVisible: t.Boolean
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        auditPreparation: getAuditPreparationDefaultState(),
        busyCounter: getBusyCounterDefaultState(),
        isAuditLoaded: false,
        isSystemSelectedClaimsModalVisible: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/state/index.js